import { Button, Modal, Form, Row, Col, message, Select } from "antd";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { handleAssignInstructor } from "../../../api/course";
import { handleFetchCompanyUser } from "../../../api/user";
import { useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";

const { Option } = Select;

export default function AssignInstructor({
  isVisible,
  setVisible,
  course_id,
}: any) {
  const { auth } = useContext(AuthContext);
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const { data: users } = useQuery({
    queryKey: ["users", auth?.company?._id],
    queryFn: () => handleFetchCompanyUser({ _id: auth?.company?._id }),
  });

  const { mutate, isLoading } = useMutation({
    mutationFn: handleAssignInstructor,
    onSuccess: () => {
      message.success("Assigned Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["courses", course_id] });
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const onSubmit = async () => {
    const { instructor } = await form.getFieldsValue();
    await mutate({ _id: course_id, data: { instructor } });
    setVisible(false);
  };

  const userOptions = users?.payload?.map((level: any, index: number) => (
    <Option value={level?._id} key={index}>
      {level?.name}
    </Option>
  ));

  const clearForm = async () => {
    form.resetFields();
  };

  return (
    <Modal
      open={isVisible}
      title="Assign Instructor"
      onCancel={() => setVisible(false)}
      footer={[
        <Button danger key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="assignInstructor"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="assignInstructor"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <div className="flex flex-row, justify-between"></div>

        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="instructor"
              label="Instructor"
              rules={[
                {
                  required: true,
                  message: "Please select instructor",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Search to Select Instructor"
                optionFilterProp="children"
                filterOption={(input: any, option: any) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {userOptions}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
